package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.product.details.ProductDetailPage

/**
 * ProductDetailData
 * Carries the parsed contentId from URL params into the page composable.
 *
 * @param contentId ID of the product content entry to fetch and display.
 */
data class ProductDetailData(val contentId: Long)

@InitRoute
fun initProductDetailRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Product Details"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val contentId = param(NavParams.CONTENT_ID).toLongOrNull() ?: 0L
    ctx.data.add(ProductDetailData(contentId = contentId))
}

@Page(routeOverride = "productdetail")
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductDetailRoute() {
    val ctx = rememberPageContext()
    val data = ctx.data.getValue<ProductDetailData>()
    ProductDetailPage(contentId = data.contentId)
}
